import { render, staticRenderFns } from "./wrongWord.vue?vue&type=template&id=e0d7d4ce&scoped=true"
import script from "./wrongWord.vue?vue&type=script&lang=js"
export * from "./wrongWord.vue?vue&type=script&lang=js"
import style0 from "./wrongWord.vue?vue&type=style&index=0&id=e0d7d4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d7d4ce",
  null
  
)

export default component.exports